import { Checkbox, SimpleGrid, Text } from "@mantine/core";
import React, { useEffect } from "react";
import TextInput from "../../../../components/Input/TextInput";

const TotalTaxDropdown = ({ form }) => {
  return (
    <>
      {/* <Checkbox label="Enter taxes manually" color="gray" size="xs" /> */}
      <SimpleGrid cols={3}>
        <Text size={"xs"} mt={"md"}>
          Sales Tax
        </Text>
        <TextInput placeholder="Vehicle Price" form={form} validateName="taxPercentage" size="xs" />
        <TextInput placeholder="Total Cost" form={form} validateName="totalTax" size="xs" disabled />
      </SimpleGrid>
    </>
  );
};

export default TotalTaxDropdown;
